<div class="container" [class.shadow]="activeFileCounter" id="bottom_toolbar">
  <div class="center75 container-fluid">
    <div id="counter" *ngIf="activeFileCounter">
      <mat-icon (click)="handleAction('clear')">close</mat-icon>
      {{ activeFileCounter }} items selected
    </div>
    <div id="counter" class="events" *ngIf="!activeFileCounter">
      {{ fileCounter }} items
    </div>
    <div id="actions" *ngIf="activeFileCounter && isClients">
<!--      <button mat-menu-item (click)="handleAction('download')">-->
<!--        <mat-icon>file_download</mat-icon>-->
<!--        Points report-->
<!--      </button>-->
      <button mat-menu-item (click)="handleAction('info')">
        <mat-icon>info</mat-icon>
        Profile info
      </button>
      <button mat-menu-item (click)="handleAction('zero')">
        <mat-icon>card_giftcard</mat-icon>
        Update bonus points
      </button>
      <button mat-menu-item (click)="handleAction('rename')">
        <mat-icon>edit</mat-icon>
        Rename
      </button>
      <button mat-menu-item (click)="handleAction('delete')">
        <mat-icon color="warn">delete</mat-icon>
        Delete
      </button>
    </div>
  </div>
</div>
